import React from "react";
import { Link } from "react-router-dom";
import utilityFunctions from "@store/utilityFunctions";

export default function CustomerInfo({ details }) {
  const safeDetails = details || {};
  const userRole = utilityFunctions.getCookieAsJson("userInfo")?.user?.role;

  return (
    <div className="card mb-3">
      <h6 className={"card-header"}>Customer Details</h6>
      <div className="card-body">
        <div className={"single-warranty-details-item"}>
          <span className={"single-warranty-details-label"}>Owner: </span>
          <span>
            {userRole === "Admin" ? (
              <Link to={"/customer-detail/" + safeDetails?.user_device?.customer_id}>
                {safeDetails?.user_device?.name}
              </Link>
            ) : (
              safeDetails?.user_device?.name
            )}
          </span>
        </div>
        <div className={"single-warranty-details-item"}>
          <span className={"single-warranty-details-label"}>Address Line 1: </span>
          <span>{safeDetails?.user_device?.address_line_one || "-"}</span>
        </div>
        <div className={"single-warranty-details-item"}>
          <span className={"single-warranty-details-label"}>Address Line 2: </span>
          <span>{safeDetails?.user_device?.address_line_two || "-"}</span>
        </div>
        <div className={"single-warranty-details-item"}>
          <span className={"single-warranty-details-label"}>Suburb: </span>
          <span>{safeDetails?.user_device?.suburb}</span>
        </div>
        <div className={"single-warranty-details-item"}>
          <span className={"single-warranty-details-label"}>State: </span>
          <span>{safeDetails?.user_device?.state}</span>
        </div>
        <div className={"single-warranty-details-item"}>
          <span className={"single-warranty-details-label"}>Post Code: </span>
          <span>{safeDetails?.user_device?.postcode}</span>
        </div>
        <div className={"single-warranty-details-item"}>
          <span className={"single-warranty-details-label"}>Mobile: </span>
          <span>{safeDetails?.user_device?.mobile}</span>
        </div>
        <div className={"single-warranty-details-item"}>
          <span className={"single-warranty-details-label"}>Email: </span>
          <span>{safeDetails?.user_device?.email}</span>
        </div>
      </div>
    </div>
  );
}
